export const fadeIn = (direction = "up", delay = 0, duration = 0.32) => ({
  hidden: {
    x: direction === "left" ? 14 : direction === "right" ? -14 : 0,
    y: direction === "up" ? 14 : direction === "down" ? -14 : 0,
    opacity: 0,
  },
  show: {
    x: 0,
    y: 0,
    opacity: 1,
    transition: {
      type: "tween",
      delay,
      duration,
      ease: [0.16, 1, 0.3, 1],
    },
  },
});

export const staggerContainer = (
  staggerChildren = 0.04,
  delayChildren = 0
) => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren,
      delayChildren,
    },
  },
});

export const scaleIn = (delay = 0, duration = 0.28) => ({
  hidden: { scale: 0.95, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: {
      type: "tween",
      delay,
      duration,
      ease: [0.16, 1, 0.3, 1],
    },
  },
});

export const slideIn = (direction, delay = 0, duration = 0.35) => ({
  hidden: {
    x: direction === "left" ? "-100%" : direction === "right" ? "100%" : 0,
    y: direction === "up" ? "100%" : direction === "down" ? "-100%" : 0,
  },
  show: {
    x: 0,
    y: 0,
    transition: {
      type: "tween",
      delay,
      duration,
      ease: [0.16, 1, 0.3, 1],
    },
  },
});

export const textReveal = (delay = 0) => ({
  hidden: { y: "100%", opacity: 0 },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      type: "tween",
      delay,
      duration: 0.45,
      ease: [0.16, 1, 0.3, 1],
    },
  },
});

const isTouchDevice =
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(pointer: coarse)")?.matches;

export const blurIn = (direction = "up", delay = 0, duration = 0.32) => ({
  hidden: {
    x: direction === "left" ? 12 : direction === "right" ? -12 : 0,
    y: direction === "up" ? 12 : direction === "down" ? -12 : 0,
    opacity: 0,
    ...(isTouchDevice ? {} : { filter: "blur(3px)" }),
  },
  show: {
    x: 0,
    y: 0,
    opacity: 1,
    ...(isTouchDevice ? {} : { filter: "blur(0px)" }),
    transition: {
      type: "tween",
      delay,
      duration,
      ease: [0.16, 1, 0.3, 1],
    },
  },
});

export const popIn = (delay = 0) => ({
  hidden: { scale: 0.94, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 26,
      delay,
    },
  },
});
